import { dateFormat } from '@constants/dateFormat'
import { retainTimes, runoutTimes } from '@constants/orderDispatch'
import moment from 'moment'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { DispatchWindowFilter } from './deprecated_DispatchWindow.component'

const now = moment().local()
const nowString = now.format(dateFormat.DATE)
const shiftStart = moment(`${nowString} 3:59 AM`)
const shiftEnd = moment(`${nowString} 4:00 PM`)
const isAm = now > shiftStart && now < shiftEnd
const amShiftToday = moment(`${nowString} 4:00 PM`).local()
const amShiftTomorrow = moment(`${nowString} 4:00 PM`).local().add(1, 'd')
const pmShiftToday = moment(`${nowString} 4:00 AM`).add(1, 'd')

/** @deprecated - Should use OrderManagement/Grid/Filters/DispatchWindow/index.tsx instead */
export default forwardRef((props, ref) => {
  const [retainValue, setRetainValue] = useState(null)
  const [runoutValue, setRunoutValue] = useState(null)
  const [isOnDemand, setIsOnDemand] = useState(false)

  const checkRetain = (rowRetainTime) => {
    const momentRetainTime = moment(rowRetainTime)
    switch (retainValue) {
      case retainTimes.NOW:
        return momentRetainTime < now
      case retainTimes.AMTODAY:
        return momentRetainTime < amShiftToday
      case retainTimes.PMTODAY:
        return momentRetainTime < pmShiftToday
      case retainTimes.AMTOMORROW:
        return momentRetainTime < amShiftTomorrow

      default:
        return true
    }
  }
  const checkRunout = (rowRunoutTime) => {
    const momentRunoutTime = moment(rowRunoutTime)
    switch (runoutValue) {
      case runoutTimes.HALFDAY:
        return momentRunoutTime.isBefore(moment().add(12, 'h'))
      case runoutTimes.DAY:
        return momentRunoutTime.isBefore(moment().local().add(24, 'h'))
      case runoutTimes.THREEDAYS:
        return momentRunoutTime.isBefore(moment().local().add(3, 'd'))
      case runoutTimes.WEEK:
        return momentRunoutTime.isBefore(moment().local().add(7, 'd'))

      default:
        return true
    }
  }

  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        let retainPasses = true
        let runoutPasses = true
        if (isOnDemand) {
          const startPasses = checkRetain(params.data.carrier_window_start)
          const endPasses = checkRunout(params.data.carrier_window_end)
          return startPasses && endPasses
        } else {
          if (params.data.type?.toLowerCase() === 'backhaul') return false
          const start = props.accessor2
            ? params.data?.[props.accessor]?.[props.accessor2]?.dispatch_window_start
            : params.data.dispatch_window_start
          const end = props.accessor2
            ? params.data?.[props.accessor]?.[props.accessor2]?.dispatch_window_end
            : params.data.dispatch_window_end
          retainPasses = checkRetain(start)
          runoutPasses = checkRunout(end)
          return retainPasses && runoutPasses
        }
      },
      isFilterActive() {
        return !!retainValue || !!runoutValue
      },
    }
  })
  useEffect(() => {
    if (props.colDef.cellRenderer === 'carrierDelWinCellRenderer') setIsOnDemand(true)
  }, [])

  useEffect(() => {
    props.filterChangedCallback()
  }, [retainValue, runoutValue])

  const onClick = (value, property) => {
    if (property === 'retainTime') {
      setRetainValue(retainValue && retainValue.includes(value) ? null : value)
    } else {
      setRunoutValue(runoutValue && runoutValue.includes(value) ? null : value)
    }
  }
  const onClear = () => {
    setRetainValue(null)
    setRunoutValue(null)
  }

  return (
    <DispatchWindowFilter
      onClick={onClick}
      retainValue={retainValue}
      runoutValue={runoutValue}
      isAm={isAm}
      onClear={onClear}
      isOnDemand={isOnDemand}
    />
  )
})
